import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Vacancies from "../pages/vacancies/page";
import PersonalAccount from "../pages/personal-account/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vacancies",
    element: <Vacancies />,
  },
  {
    path: "/personal-account",
    element: <PersonalAccount />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;